import React from "react";

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.linksContainer}>
        <a href="/contact" style={styles.link}>Contacts</a>
        <a href="/about" style={styles.link}>À propos</a>
        <a href="/confidential" style={styles.link}>CGV, CGU & Politique de confidentialité</a>
      </div>
      <div style={styles.copy}>
        &copy; {new Date().getFullYear()} DNS. Tous droits réservés.
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    background: "#f5f5f5",
    padding: "20px 0",
    textAlign: "center",
    borderTop: "1px solid #e0e0e0",
    marginTop: 40,
  },
  linksContainer: {
    marginBottom: 10,
  },
  link: {
    margin: "0 15px",
    color: "#333",
    textDecoration: "none",
    fontWeight: 500,
    fontSize: 16,
  },
  copy: {
    color: "#888",
    fontSize: 14,
  },
};
